module.exports = __webpack_public_path__ + "img/5.011c81f.svg";